import { shareSurveyStore } from "../stores/share-survey.store";

export const useShareSurveyStore = () => shareSurveyStore;
